import { requestGet, requestPost } from '@/common/request';

// 2.0招商池素材列表
// 招商池-完善素材列表
export const getMaterialList = async (query) => {
  return await requestPost(
    // 'http://mock.yfecj.jd.com/mock/5d3aa912365abf552c924ec5/v1/goodsPool/apply/querySkuMaterials',
    '/generic/themeActivity/yxMaterialApiService/querySkuMaterials',
    query
  );
};

// 2.0招商池素材列表
// 招商池-完善素材列表
export const saveMaterial = async (query) => {
  return await requestPost(
    // 'http://mock.yfecj.jd.com/mock/5d3aa912365abf552c924ec5/v1/goodsPool/apply/querySkuMaterials',
    '/generic/yxApplyWriteService/updateSkuMaterials',
    query
  );
};

// 2.0招商池素材抠图
// 招商池-抠图
export const createSkuMaterialPic = async (query) => {
  return await requestPost(
    // 'http://mock.yfecj.jd.com/mock/5d3aa912365abf552c924ec5/v1/goodsPool/apply/createSkuMaterialPic',
    '/generic/yxApplyReadService/querySkuMaterialPic',
    query
  );
};
// 2.0招商池素材抠图
// 我的商品 - 完善商品信息气泡提示
export const getGoodsGuide = async ({ planCode, type }) => {
  return await requestGet('/myGoods/guide', { planCode, type });
};

// 获取spu列表
export const querySpuForPageList = async (query) => {
  return await requestPost('/generic/themeActivity/yxApplyApiService/querySpuForPageList', query);
};

// 批量保存sku
export const batchUpdateSkuMaterials = async (query) => {
  return await requestPost('/generic/themeActivity/yxApplyApiService/batchUpdateSkuMaterials', query);
};
